import "core-js/modules/es6.array.find";
import "core-js/modules/es6.promise";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.find-index";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.string.starts-with";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import ApiService from '../../services/apiService';
import tenantPickerMixin from '../../components/core/tenant/pickerMixin';
import get from 'lodash/get';
import cloneDeep from 'lodash/cloneDeep';
import debounce from 'lodash/debounce';
var DEFAULT_MODULE_SETTINGS = {
  wMBus: {
    deviceLimit: 0,
    activeDeviceLimit: false
  }
};
var RETENTION_POLICY_DEFAULT = 24;
var CSV_EXPORT_LIMIT = 500000;
var TEMPLATE_LIMIT_DEFAULT = 0;
export default {
  name: 'ViewAccountMgmtAccountMgmtModules',
  mixins: [tenantPickerMixin],
  data: function data() {
    var _this = this;

    return {
      formIsValid: false,
      loadingModules: true,
      modules: [],
      moduleDisablePrompt: false,
      moduleToDisable: null,
      tenantDefaultRoles: [],
      superAdminModuleInteraction: false,
      positiveNumberRule: function positiveNumberRule(v) {
        return /^[0-9]+$/.test(v) ? true : _this.$i18n_t('DigitalTwin.DigitalTwin.share.mapUrlParamsLabels.ruleError');
      }
    };
  },
  computed: {
    retentionPolicyRules: function retentionPolicyRules() {
      var _this2 = this;

      return [function (v) {
        return !!v && (isNaN(parseFloat(v)) || parseFloat(v) <= 0.1 ? _this2.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.geoFences.numberRule') : true) || _this2.$i18n_t('Common.fieldRequired');
      }];
    },
    hasCustomLimit: function hasCustomLimit() {
      return get(this.tenantModel, 'data.useCustomTemplateLimit');
    }
  },
  watch: {
    selectedTenantId: function selectedTenantId() {
      this.fetchTenantModules();
      this.tenantModel.data.retentionPolicyMonths = this.tenantModel.data.retentionPolicyMonths || RETENTION_POLICY_DEFAULT;
      this.tenantModel.data.csvExportLimit = this.tenantModel.data.csvExportLimit || CSV_EXPORT_LIMIT;
      this.tenantModel.data.templateLimit = this.tenantModel.data.templateLimit || TEMPLATE_LIMIT_DEFAULT;
    }
  },
  mounted: function mounted() {
    this.loadTenants();
  },
  methods: {
    updateRetentionPolicy: function updateRetentionPolicy() {
      if (this.retentionPolicyRules[0](this.tenantModel.data.retentionPolicyMonths) === true) {
        this.updateRetentionPolicyRequest();
      }
    },
    updateRetentionPolicyRequest: debounce(function () {
      var _this3 = this;

      ApiService.tenantUpdateRetentionPolicy({
        id: this.tenantModel.id,
        retentionPolicyMonths: this.tenantModel.data.retentionPolicyMonths
      }).catch(function (error) {
        console.error('Retention-Policy update error', error);

        if (error.response && _this3.$i18n_t("Error.".concat(error.response.data.message))) {
          _this3.$snack(_this3.$i18n_t("Error.".concat(error.response.data.message)), 'error');
        } else {
          console.error(error);

          _this3.$snack(_this3.$i18n_t('Common.oops1'), 'error');
        }
      });
    }, 500),
    updateCsvExportLimit: debounce(function () {
      var _this4 = this;

      if (get(this.tenantModel, 'data.csvExportLimit') && !/^[0-9]+$/.test(this.tenantModel.data.csvExportLimit)) {
        return;
      }

      ApiService.tenantUpdateCsvExportLimit({
        id: this.tenantModel.id,
        csvExportLimit: this.tenantModel.data.csvExportLimit
      }).catch(function (error) {
        console.error('Csv export limit update error', error);

        if (error.response && _this4.$i18n_t("Error.".concat(error.response.data.message))) {
          _this4.$snack(_this4.$i18n_t("Error.".concat(error.response.data.message)), 'error');
        } else {
          console.error(error);

          _this4.$snack(_this4.$i18n_t('Common.oops1'), 'error');
        }
      });
    }, 500),
    updateDeviceTemplateSettings: debounce(function () {
      var _this5 = this;

      if (get(this.tenantModel, 'data.templateLimit') && !/^[0-9]+$/.test(this.tenantModel.data.templateLimit)) {
        return;
      }

      ApiService.tenantUpdateTemplatesLimit({
        id: this.tenantModel.id,
        templateLimit: this.tenantModel.data.templateLimit,
        useCustomTemplateLimit: this.tenantModel.data.useCustomTemplateLimit
      }).catch(function (error) {
        console.error('Device template settings update error', error);

        if (error.response && _this5.$i18n_t("Error.".concat(error.response.data.message))) {
          _this5.$snack(_this5.$i18n_t("Error.".concat(error.response.data.message)), 'error');
        } else {
          console.error(error);

          _this5.$snack(_this5.$i18n_t('Common.oops1'), 'error');
        }
      });
    }, 500),
    confirmModuleDisable: function confirmModuleDisable(moduleModel, $event) {
      if (moduleModel.manifest.superAdminModule) {
        // this is a super-admin module, but user has no Super-Admin rights
        if (!this.permissions['super.system.manage']) {
          // force refresh/redraw the v-switch
          // cloneDeep does not do the trick (alone) to reset the switch to its "old" value,
          // need to change the key manually here to re-draw it
          moduleModel.tempKey = new Date().toISOString();
          this.modules = cloneDeep(this.modules);
          this.superAdminModuleInteraction = true;
          return;
        }
      }

      moduleModel.isEnabled = $event;

      if (!moduleModel.isEnabled) {
        // user wants to disable and enabled module, so confirm with the user
        this.moduleToDisable = moduleModel;
        this.moduleDisablePrompt = true;
      } else {
        // if a module is enabled, nothing to do here
        this.toggleModule(moduleModel);
      }
    },
    cancelModuleDisablement: function cancelModuleDisablement() {
      if (this.moduleToDisable) {
        this.moduleToDisable.isEnabled = true;
        this.moduleDisablePrompt = false;
        this.moduleToDisable = null;
      }
    },
    toggleModule: debounce(function (moduleModel) {
      var _this6 = this;

      if (get(moduleModel, 'settings.deviceLimit') && !/^[0-9]+$/.test(moduleModel.settings.deviceLimit)) {
        return;
      }

      this.moduleDisablePrompt = false;
      this.moduleToDisable = null;
      moduleModel.modulesSettings = moduleModel.modulesSettings || {};

      if (moduleModel.key === 'wMBus') {
        if (moduleModel.settings.activeDeviceLimit) {
          moduleModel.modulesSettings.wMBus = {
            activeDeviceLimit: moduleModel.settings.activeDeviceLimit,
            deviceLimit: moduleModel.settings.deviceLimit || 0
          };
        } else {
          moduleModel.modulesSettings.wMBus = {
            activeDeviceLimit: moduleModel.settings.activeDeviceLimit
          };
        }
      }

      this.loadingModules = true; //moduleModel.key;

      return ApiService.tenantToggleModule(this.selectedTenantId, moduleModel.key, moduleModel.isEnabled, moduleModel.modulesSettings).then(function () {
        return _this6.fetchTenantModules();
      }).catch(function (error) {
        moduleModel.isEnabled = !moduleModel.isEnabled; // force refresh/redraw the v-switch
        // cloneDeep does not do the trick (alone) to reset the switch to its "old" value,
        // need to change the key manually here to re-draw it

        moduleModel.tempKey = new Date().toISOString();
        _this6.modules = cloneDeep(_this6.modules);

        if (get(error, 'response.status') === 401) {
          if (error.response.data.message.startsWith('NO_PERMISSION_')) {
            var rule = error.response.data.message.replace('NO_PERMISSION_', '').split('.');

            if (rule.length >= 2) {
              var subject = _this6.$i18n_t("Error.permissions.".concat(rule[0])) || rule[0];
              var action = _this6.$i18n_t("Error.permissions.".concat(rule[1])) || rule[1];

              _this6.$snack(_this6.$i18n_t('Error.NO_PERMISSION_', {
                subject: subject,
                action: action
              }), 'error');

              return;
            }
          }
        }

        console.error('Module toggle error', error);

        if (error.response && _this6.$i18n_t("Error.".concat(error.response.data.message))) {
          _this6.$snack(_this6.$i18n_t("Error.".concat(error.response.data.message)), 'error');
        } else {
          _this6.$snack(_this6.$i18n_t('Common.oops1'), 'error');
        }
      }).finally(function () {
        _this6.loadingModules = false;
      });
    }, 500),
    toggleDefaultRole: function toggleDefaultRole(role) {
      var _this7 = this;

      var defaultRoles = cloneDeep(this.tenantDefaultRoles);
      var roleIsActive = defaultRoles.findIndex(function (defaultRole) {
        return defaultRole.id === role.id;
      }) >= 0;

      if (roleIsActive) {
        defaultRoles = defaultRoles.filter(function (defaultRole) {
          return defaultRole.id !== role.id;
        });
      } else {
        defaultRoles.push({
          id: role.id
        });
      }

      this.loadingModules = true; //moduleModel.key;

      ApiService.updateDefaultRoles(this.getTenantById(this.selectedTenantId).scopeId, defaultRoles.map(function (role) {
        return role.id;
      })).then(function () {
        return _this7.fetchTenantModules();
      }).catch(function (error) {
        console.error('Role toggle error', error);

        if (error.response && _this7.$i18n_t("Error.".concat(error.response.data.message))) {
          _this7.$snack(_this7.$i18n_t("Error.".concat(error.response.data.message)), 'error');
        } else {
          console.error(error);

          _this7.$snack(_this7.$i18n_t('Common.oops1'), 'error');
        }
      }).finally(function () {
        _this7.loadingModules = false;
      });
    },
    fetchTenantModules: function fetchTenantModules() {
      var _this8 = this;

      // if set, keep the module-key here
      this.loadingModules = this.loadingModules || true;

      if (this.selectedTenantId === undefined) {
        return;
      }

      return Promise.all([ApiService.fetchDefaultRoles(this.getTenantById(this.selectedTenantId).scopeId, true), ApiService.tenantFetchModules(this.selectedTenantId)]).then(function (data) {
        _this8.tenantDefaultRoles = data[0];
        _this8.modules = data[1];
        var wmbusModule = data[1].find(function (d) {
          return d.manifest.key === 'wMBus';
        });

        if (wmbusModule !== undefined && !wmbusModule.settings) {
          wmbusModule.settings = cloneDeep(DEFAULT_MODULE_SETTINGS);
        }

        _this8.loadingModules = false;
      }).catch(function (error) {
        if (error.response && _this8.$i18n_t("Error.".concat(error.response.data.message))) {
          _this8.$snack(_this8.$i18n_t("Error.".concat(error.response.data.message)), 'error');
        } else {
          console.error(error);

          _this8.$snack(_this8.$i18n_t('Common.oops1'), 'error');
        }
      });
    }
  }
};